import type { ContentCta as ContentCtaType } from "@nnf3d/studio/types";
import type { PortableTextTypeComponentProps } from "@portabletext/react";

import type { ParentComponent } from "../../lib/types";
import { Icon } from "../icon";

const ContentCta: ParentComponent<PortableTextTypeComponentProps<ContentCtaType>> = ({ value }) => (
	<a
		href={value.url}
		target="_blank"
		className="my-7 flex min-h-12 w-fit items-center gap-1.5 hover-cta ps-5.5 pe-4 text-xs"
		data-disable-focus-ring=""
	>
		<span className="flex-1">{value.text}</span>

		<Icon name="arrow-up-right" className="size-5 shrink-0" />
	</a>
);

export { ContentCta };
